/*
 *
 *  * Copyright (c) [hoarfroster-frontend] 2026. All Rights Reserved.
 *  *
 *  * Last Modified on Sep 12, 2026 by hoarfroster
 *
 */

export const MODAL_LAYER_SELECTOR = '[data-modal-layer="true"]';

/**
 * True when `panel` is the last modal layer in document order. Modals,
 * sheets and popover panels mark themselves with `data-modal-layer="true"`
 * so Escape only ever closes the one on top.
 */
export function isTopMostModalLayer(panel: HTMLElement | null): boolean {
    if (!panel) return false;
    const layers = document.querySelectorAll(MODAL_LAYER_SELECTOR);
    return layers.length === 0 || layers[layers.length - 1] === panel;
}
